<div class="flex flex-col flex-auto min-w-0 h-full bg-gray-50 dark:bg-gray-900">
    <div class="sticky top-0 z-10 bg-white dark:bg-gray-800 shadow-sm border-b dark:border-gray-700 p-4 sm:px-6 lg:px-8">
        <div class="flex items-center justify-between">
            <div class="flex items-center gap-4">
                <button mat-icon-button (click)="goBack()">
                    <mat-icon [svgIcon]="'heroicons_outline:arrow-left'"></mat-icon>
                </button>
                <div class="flex flex-col">
                    <h1 class="text-2xl font-bold tracking-tight text-gray-900 dark:text-white leading-tight">
                        {{ isEditMode ? 'Manage User' : 'Create New User' }}
                    </h1>
                    <p class="text-sm text-gray-500 dark:text-gray-400" *ngIf="isEditMode">ID: {{ userId }}</p>
                </div>
            </div>

            <div class="flex items-center gap-3" *ngIf="isEditMode && !isLoading && !errorMessage">
                <button mat-stroked-button color="warn" (click)="openDeleteDialog()">
                    <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                    <span class="ml-2">Delete User</span>
                </button>
            </div>
        </div>
    </div>

    <div class="flex-auto p-4 sm:p-6 lg:p-8 overflow-y-auto" *ngIf="!isLoading && !errorMessage">
        <form [formGroup]="userForm" class="max-w-5xl mx-auto space-y-8">

            <div class="bg-white dark:bg-card rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 p-6 sm:p-8">
                <h2 class="text-lg font-semibold mb-6 flex items-center">
                    <mat-icon class="mr-2 text-primary" [svgIcon]="'heroicons_outline:user'"></mat-icon>
                    Personal Information
                </h2>

                <div class="grid grid-cols-1 gap-6" [ngClass]="isEditMode ? 'sm:grid-cols-3' : 'sm:grid-cols-2'">
                    <mat-form-field class="w-full">
                        <mat-label>First Name</mat-label>
                        <input matInput formControlName="ds_firstname">
                        <mat-error *ngIf="userForm.get('ds_firstname')?.hasError('required') || userForm.get('ds_firstname')?.hasError('pattern')">ds_firstname is required</mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full" *ngIf="isEditMode">
                        <mat-label>Middle Name</mat-label>
                        <input matInput formControlName="ds_middlename">
                    </mat-form-field>

                    <mat-form-field class="w-full">
                        <mat-label>Last Name</mat-label>
                        <input matInput formControlName="ds_lastname">
                        <mat-error *ngIf="userForm.get('ds_lastname')?.hasError('required') || userForm.get('ds_lastname')?.hasError('pattern')">ds_lastname is required</mat-error>
                    </mat-form-field>
                </div>

                <div class="grid grid-cols-1 gap-6 mt-6" [ngClass]="isEditMode ? 'sm:grid-cols-2' : ''">
                    <mat-form-field class="w-full">
                        <mat-label>Email Address</mat-label>
                        <input matInput formControlName="ds_email">
                        <mat-icon matPrefix [svgIcon]="'heroicons_outline:envelope'"></mat-icon>
                        <mat-error *ngIf="userForm.get('ds_email')?.hasError('required')">ds_email is required</mat-error>
                        <mat-error *ngIf="userForm.get('ds_email')?.hasError('email')">ds_email is invalid</mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full" *ngIf="isEditMode">
                        <mat-label>Phone Number</mat-label>
                        <input matInput formControlName="ds_phone">
                        <mat-icon matPrefix [svgIcon]="'heroicons_outline:phone'"></mat-icon>
                    </mat-form-field>
                </div>

                <div class="mt-6" *ngIf="isEditMode">
                    <mat-form-field class="w-full">
                        <mat-label>Biography</mat-label>
                        <textarea matInput formControlName="tx_biography" rows="3"></textarea>
                    </mat-form-field>
                </div>
            </div>

            <div class="bg-white dark:bg-card rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 p-6 sm:p-8">
                <h2 class="text-lg font-semibold mb-6 flex items-center">
                    <mat-icon class="mr-2 text-primary" [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
                    System Settings & Status
                </h2>

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
                    <mat-form-field class="w-full" *ngIf="isEditMode">
                        <mat-label>Account ID</mat-label>
                        <input matInput formControlName="ds_accountid" readonly>
                    </mat-form-field>

                    <mat-form-field class="w-full" *ngIf="isEditMode">
                        <mat-label>Account Status</mat-label>
                        <mat-select formControlName="en_accountstatus">
                            <mat-option [value]="0">Active</mat-option>
                            <mat-option [value]="1">Inactive</mat-option>
                            <mat-option [value]="2">Locked</mat-option>
                            <mat-option [value]="3">Deleted</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field class="w-full">
                        <mat-label>Login Type</mat-label>
                        <mat-select formControlName="en_logintype">
                            <mat-option [value]="1">Member</mat-option>
                            <mat-option [value]="2">Destination Owner</mat-option>
                            <mat-option [value]="3">Admin Console</mat-option>
                            <mat-option [value]="4">Ambassador</mat-option>
                        </mat-select>
                        <mat-error *ngIf="userForm.get('en_logintype')?.hasError('required')">en_logintype is invalid</mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full" *ngIf="isEditMode">
                        <mat-label>Notification Settings</mat-label>
                        <mat-select formControlName="en_notificationsettings">
                            <mat-option [value]="0">Default</mat-option>
                            <mat-option [value]="1">All</mat-option>
                            <mat-option [value]="2">None</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="border-t border-gray-100 dark:border-gray-700 pt-6" *ngIf="isEditMode">
                    <h3 class="text-sm font-medium text-gray-500 mb-4">Location (Read-Only)</h3>
                    <div class="grid grid-cols-1 sm:grid-cols-3 gap-6">
                        <mat-form-field class="w-full">
                            <mat-label>Country ID</mat-label>
                            <input matInput formControlName="id_country">
                        </mat-form-field>
                        <mat-form-field class="w-full">
                            <mat-label>Region ID</mat-label>
                            <input matInput formControlName="id_region">
                        </mat-form-field>
                        <mat-form-field class="w-full">
                            <mat-label>Language ID</mat-label>
                            <input matInput formControlName="id_language">
                        </mat-form-field>
                    </div>
                </div>

                <div class="border-t border-gray-100 dark:border-gray-700 pt-6" *ngIf="isEditMode">
                    <h3 class="text-sm font-medium text-gray-500 mb-4">Permissions & Opt-ins</h3>
                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                        <mat-checkbox formControlName="bl_terms" color="primary">Terms Accepted</mat-checkbox>
                        <mat-checkbox formControlName="bl_privacy" color="primary">Privacy Accepted</mat-checkbox>
                        <mat-checkbox formControlName="bl_optinlocation" color="primary">Location Tracking</mat-checkbox>
                        <mat-checkbox formControlName="bl_optinnewsletter" color="primary">Newsletter</mat-checkbox>
                    </div>
                </div>
            </div>

            <div class="bg-white dark:bg-card rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 p-6 sm:p-8">
                <h2 class="text-lg font-semibold mb-6 flex items-center">
                    <mat-icon class="mr-2 text-primary" [svgIcon]="'heroicons_outline:shield-check'"></mat-icon>
                    Security
                </h2>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">

                    <div class="flex flex-col gap-4">
                        <mat-form-field class="w-full">
                            <mat-label>{{ isEditMode ? 'Force New Password' : 'Password' }}</mat-label>
                            <input matInput type="password" formControlName="ds_password"
                                   [placeholder]="isEditMode ? 'Enter a new password' : ''">
                            <mat-icon matPrefix [svgIcon]="'heroicons_outline:key'"></mat-icon>
                            <mat-error *ngIf="userForm.get('ds_password')?.hasError('minlength')">ds_password must be at least 8 characters</mat-error>
                        </mat-form-field>

                        <div *ngIf="isEditMode" class="flex flex-col sm:flex-row gap-3">
                            <button mat-flat-button color="primary" type="button" (click)="forceResetPassword()" [disabled]="!userForm.get('ds_password').value || userForm.get('ds_password').invalid">
                                <mat-icon [svgIcon]="'heroicons_outline:key'"></mat-icon>
                                <span class="ml-2">Update Password</span>
                            </button>
                            <button mat-stroked-button type="button" (click)="sendResetPasswordEmail()">
                                <mat-icon [svgIcon]="'heroicons_outline:paper-airplane'"></mat-icon>
                                <span class="ml-2">Send Reset Email</span>
                            </button>
                        </div>
                    </div>

                    <div class="flex flex-col gap-4 border-l pl-8 dark:border-gray-700" *ngIf="isEditMode">
                        <mat-form-field class="w-full">
                            <mat-label>Login Attempts</mat-label>
                            <input matInput type="number" formControlName="vi_loginattempts">
                        </mat-form-field>
                        <div>
                            <button mat-stroked-button type="button" (click)="resetLoginAttempts()">
                                <mat-icon [svgIcon]="'heroicons_outline:arrow-path'"></mat-icon>
                                <span class="ml-2">Reset Login Attempts</span>
                            </button>
                        </div>
                    </div>

                </div>
            </div>

            <div class="flex items-center justify-end gap-3 pt-4 pb-8">
                <button mat-button type="button" [disabled]="isSaving" (click)="goBack()">Cancel</button>
                <button mat-flat-button color="primary" type="button" [disabled]="isSaving" (click)="saveUser()">
                    <mat-icon *ngIf="isSaving" class="animate-spin mr-2" [svgIcon]="'heroicons_outline:arrow-path'"></mat-icon>
                    {{ isEditMode ? 'Save Changes' : 'Create User' }}
                </button>
            </div>

        </form>
    </div>

    <div class="flex-auto flex flex-col items-center justify-center p-8" *ngIf="isLoading">
        <mat-progress-spinner mode="indeterminate" color="primary" [diameter]="40"></mat-progress-spinner>
        <p class="mt-4 text-gray-500">Loading user details...</p>
    </div>

    <div class="flex-auto flex flex-col items-center justify-center p-8 text-red-500" *ngIf="!isLoading && errorMessage">
        <mat-icon class="icon-size-12 mb-4" [svgIcon]="'heroicons_outline:exclamation-triangle'"></mat-icon>
        <p class="text-lg">{{ errorMessage }}</p>
        <button mat-button color="warn" class="mt-4" (click)="loadUser()">Try Again</button>
    </div>
</div>

<ng-template #notImplementedDialog>
    <div class="p-6">
        <div class="flex flex-col items-center text-center gap-4">
            <div class="bg-amber-100 text-amber-600 rounded-full p-4">
                <mat-icon class="icon-size-8" [svgIcon]="'heroicons_outline:wrench-screwdriver'"></mat-icon>
            </div>
            <h2 class="text-xl font-bold m-0">Feature Not Yet Implemented</h2>
            <p class="text-gray-500 m-0">
                The API endpoint for deleting users (/admin/account/deleteUser) is not yet available in the system.
            </p>
            <button mat-flat-button color="primary" class="mt-4 w-full" mat-dialog-close>Understood</button>
        </div>
    </div>
</ng-template>
